var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-progress-circular',{attrs:{"rotate":-90,"size":80,"width":12,"value":_vm.percentual,"color":_vm.setColor(_vm.percentual)}},[_c('span',{staticStyle:{"color":"black !important","font-size":"1.4em"}},[_vm._v(_vm._s(_vm.percentual)+"%")])])
}
var staticRenderFns = []

export { render, staticRenderFns }